class FooterNavigation extends HTMLElement {
  constructor() {
    super();

    this.mobileBreakpoint = 750;
    this.detailsElements = this.querySelectorAll('details');
    this.handleResize = this.handleResize.bind(this);
  }

  connectedCallback() {
    this.setupEventListeners();
    this.handleResize();
  }

  setupEventListeners() {
    window.addEventListener('resize', this.handleResize);
  }

  handleResize() {
    const isMobile = window.innerWidth < this.mobileBreakpoint;

    if (isMobile) {
      this.closeAllExceptFirst();
    } else {
      this.openAll();
    }
  }

  closeAllExceptFirst() {
    this.detailsElements.forEach((details, index) => {
      if (index === 0) {
        details.setAttribute('open', '');
      } else {
        details.removeAttribute('open');
      }
    });
  }

  openAll() {
    this.detailsElements.forEach((details) => {
      details.setAttribute('open', '');
    });
  }
}

if (!customElements.get('footer-navigation')) {
  customElements.define('footer-navigation', FooterNavigation);
}
